import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import useDialogState, { UseDialogStateReturn } from 'hooks/useDialogState';
import ImageSelectPopup from '@/pages/resources/images/image-select-popup';

class Gallery extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('gallery', locale => {
      // The button will be an instance of ButtonView.
      const buttonView = new ButtonView();

      buttonView.set({
        label: 'Gallery',
        withText: true,
      });

      buttonView.on('execute', () => {
        const c: any = editor.config.get('gallery');
        c?.openDialog?.({
          onOk: (data: any) => {
            //Change the model using the model writer
            // editor.model.change(writer => {
            //   //Insert the text at the user's current position
            //   editor.model.insertContent(writer.createText(JSON.stringify(data)));
            // });
            editor.execute('insertImage', {
              source: data.map(f => ({
                src: f.url,
                alt: f.filename,
              })),
            });
          },
        });
      });

      return buttonView;
    });
  }
}

export const useGalleryPlugin = () => {
  const dialogState = useDialogState();
  return dialogState;
};

export const GallerySelectDialog = ({gallery}: {gallery: UseDialogStateReturn}) => {
  if (!gallery || !gallery.open) return null;
  return (
    <ImageSelectPopup
      open={gallery.open}
      closeDialog={gallery.closeDialog}
      onOk={gallery.extraData?.onOk}
    />
  );
};

export default Gallery;
